import * as React from 'react';

function SvgZoom(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M13 0v3.06A9 9 0 0120.95 11H24v2h-3.06A9 9 0 0113 20.94V24h-2v-3.05A9 9 0 013.06 13H0v-2h3.05A9 9 0 0111 3.05V0h2zm0 5.07v3.06a4 4 0 00-2 0V5.07A7 7 0 005.07 11h3.06a4 4 0 000 2H5.07A7 7 0 0011 18.93v-3.06a4 4 0 002 0v3.06A7 7 0 0018.93 13h-3.06a4 4 0 000-2h3.06A7 7 0 0013 5.07z" />
    </svg>
  );
}

export default SvgZoom;
